export function afterPasswordChange() {

  const link = document.querySelector('#login_link_after_pass_change')
  if (link) {
    onAfterPassChange()
  }

  function onAfterPassChange() {
    // Add click event listener to the link
    link.addEventListener("click", function (event) {

      // Prevent the default action (i.e., following the link)
      event.preventDefault();

      // The URL to make the API call to log out user
      const apiUrl = "/en/api-logout";

      // Perform API call using fetch
      fetch(apiUrl, {
        method: "GET"
      })
        .then(response => response.json())
        .then(data => {
          // Redirect to the original link href
          window.location.href = event.target.href;
        })
        .catch(error => {
          console.error("API call failed:", error);
        });
    });
  }
}
